import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  root: {
    position: "relative",
  },
  wrapper: {
    height: "190px",
    display: "flex",
    borderRadius: "4px",
    // border: "1px solid #aaa",
    boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    backgroundColor: "white",
    padding: "20px 8px",
    justifyContent: "space-around",
    alignItems: "center",
    position: "absolute",
    gap: "0px",
    zIndex: 300,
    maxWidth: "240px",
    top: "6px",
    left: "1px",
  },
  closeBtn: {
    position: "absolute",
    right: "5px",
    top: "5px",
    backgroundColor: "#155eef",
    borderRadius: "6px",
    width: "25px",
    height: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#1150d0", // Darker shade on hover
    },
  },
  closeIcon: {
    color: "#fff",
  },
  actionBtn: {
    backgroundColor: "transparent",
    borderRadius: "6px",
    // border: "1px solid #aaa",
    margin: "8px 7px",
    padding: "6px 4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // Add hover effect
    "&:hover": {
      borderColor: "primary.main",
    },
  },
  next: {},
  prev: {},
  imgContainer: {
    height: "100%",
    width: "20vw",
    overflow: "hidden",
    padding: "0px 0px",
  },
  imgCarousel: {
    display: "flex",
    height: "100%",
    width: "100%",
    gap: "100px",
    position: "relative",
    "& img": {
      height: "100%",
      width: "100%",
      objectFit: "contain",
      borderRadius: "10px",
      position: "absolute",
      transition: "1s",
      padding: "0px 0px",
    },
  },
}));
